var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"items":_vm.items,"headers":_vm.headers,"hide-default-footer":"","disable-sort":""},scopedSlots:_vm._u([{key:"item.operation",fn:function(ref){
var item = ref.item;
return [_c('v-chip',{attrs:{"color":_vm.getColor(item),"text-color":"white"}},[_vm._v(" "+_vm._s(item.operation)+" ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }